import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ParametrosvariablesService, IParametrosVariablesRequest } from '@p-parametria/parametros/services/parametrosvariables.service';
import { SwalService } from '@shared/utils/swal.service';

@Component({
  selector: 'app-parametros-variables-form',
  templateUrl: './parametros-variables-form.component.html',
  styleUrls: ['./parametros-variables-form.component.css']
})
export class ParametrosVariablesFormComponent implements OnInit {
  @Input() modelRecived: any;
  public loading: boolean = false;
  listParametro: any[] = [];
  listProducto: any[] = [];

  form = this._fb.group({
    parametro: ['', Validators.required],
    producto: [''],
    valor: ['', Validators.required],
    descripcion: ['', Validators.required]
  });

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: DynamicDialogRef,
    private parametrosvariablesService: ParametrosvariablesService,
    private _swalService: SwalService,
    public config: DynamicDialogConfig
  ) {
    this.modelRecived = this.config.data;
  }

  ngOnInit(): void {
    this.setForm();
    this.loadParametros();
    this.loadProductos();
  }

  loadParametros() {
    this.parametrosvariablesService.GetOpciones().subscribe({
      next: (response) => {
        if (response.success) {
          this.listParametro = response.data.map(item => ({
            value: item.sValor?.trim(),
            label: item.sOpcion?.trim()
          }));
        } else {
          console.error('Error al cargar parámetros:', response);
          this._swalService.error('Error al cargar la lista de parámetros');
        }
      },
      error: (error) => {
        console.error('Error al cargar parámetros:', error);
        this._swalService.error('Error al cargar la lista de parámetros');
      }
    });
  }

  loadProductos() {
    this.parametrosvariablesService.GetPromociones().subscribe({
      next: (response) => {
        if (response.success) {
          this.listProducto = response.data.map(item => ({
            value: item.producto,
            label: `${item.producto} | ${item.descripcion}`
          }));
        } else {
          console.error('Error al cargar promociones:', response);
          this._swalService.error('Error al cargar la lista de promociones');
        }
      },
      error: (error) => {
        console.error('Error al cargar promociones:', error);
        this._swalService.error('Error al cargar la lista de promociones');
      }
    });
  }

  formValue(value: string) {
    return this.form.get(value);
  }

  setForm(): void {
    if (this.modelRecived) {
      const setModel = {
        parametro: this.modelRecived.parametro,
        producto: this.modelRecived.producto,
        valor: this.modelRecived.valor,
        descripcion: this.modelRecived.descripcion,
      };
      // Deshabilitar campos que no deben modificarse en edición
      this.form.controls["parametro"].disable();
      this.form.controls["producto"].disable();
      this.form.patchValue(setModel);
    }
  }

  create(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const payload: IParametrosVariablesRequest = {
        que: 1,
        tope: "",
        cmd: "",
        parametro: model.parametro,
        promocion: model.producto || '',
        valor: model.valor,
        descripcion: model.descripcion
      };

      this.parametrosvariablesService.ParametrosVariablesAdd(payload).subscribe({
        next: (response) => {
          this.loading = false;
          if (response.success && response.data) {
            this._dialogRef.close(true);
            this._swalService.success('Parámetro variable agregado correctamente');
          } else {
            this._swalService.error('Error al agregar el parámetro variable. El código puede estar duplicado.');
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          this.loading = false;
          this._swalService.error('Error al agregar el parámetro variable');
        }
      });
    }
  }

  update(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const payload: IParametrosVariablesRequest = {
        que: 2,
        tope: "",
        cmd: "",
        parametro: model.parametro,
        promocion: model.producto,
        valor: model.valor,
        descripcion: model.descripcion
      };

      console.log('Payload update:', payload);

      this.parametrosvariablesService.ParametrosVariablesUpd(payload).subscribe({
        next: (response) => {
          this.loading = false;
          if (response.success && response.data) {
            this._dialogRef.close(true);
            this._swalService.success('Parámetro variable actualizado correctamente');
          } else {
            this._swalService.error('Error al actualizar el parámetro variable');
          }
        },
        error: (error) => {
          console.error('Error al actualizar:', error);
          this.loading = false;
          this._swalService.error('Error al actualizar el parámetro variable');
        }
      });
    }
  }

  close(): void {
    this._dialogRef.close();
  }
}
